export enum WorkType {
  Remote = "remote",
  Hybrid = "hybrid",
  Onsite = "onsite",
}
